import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Grid, Stack, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import capitalize from '../../../utils/capitalize';
import { ButtonsPrimary, ButtonsSecondary } from '../../ComponentApp/buttoms';
import ChartDoughnutXcala from '../../XcalaComponents/ChartDoughnutXcala';
import {
  BodyComponent,
  BtnContainer,
  BtnGroupContainer,
  BtnGroupPortfolio,
  ButtonReInvestment,
  ButtonsWrapperStack,
  CardExpectedReturn,
  CardsContentDocumentacion,
  ChartsPorfolio,
  ContainerPortfolioDetails,
  DataCharts,
  Description,
  DescriptionDataPorfo,
  HeaderComponent,
  IconInfo,
  InfoPorfolio,
  SectionDataPorfolio,
  StackDescription,
  SubTitleCardsDocumentation,
  TitelDataPorfolio,
  TitleCardsDocumentation,
  TitleDescription,
  TopSectionPortfolio,
  TypographyTitleExpected,
  TypographyValueExpected,
} from '../../XcalaComponents/PorfolioComponents';
import CardsItemDescription from '../CardsItemDescription';
import DescriptionComponentPortfolio from './DescriptionComponentPortfolio';
import DistributionsValue from './DistributionsValue';
import { BtnGroup } from './distributionFunds/BtnGroup';

const BodyDetailsPorfolio = ({
  dataDetailsPortfolioId,
  portfolioDetailsFileAs,
  shouldShowWarning,
  simulation = ' Rescatar Inversión',
  fileAs,
  visible,
  statusDividendFinfolio,
  handleClose,
  handleOpen,
  investmentMore = ' Invertir Más',
}) => {
  const handleHexToRgba = hex => {
    const r = Number.parseInt(hex.substring(1, 3), 16);
    const g = Number.parseInt(hex.substring(3, 5), 16);
    const b = Number.parseInt(hex.substring(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, 0.2)`;
  };
  const theme = useTheme();
  const [userNotOB, setUserNotOB] = useState(false);
  const { user } = useSelector(state => state.auth);

  const navigate = useNavigate();
  const dataDetailsPortfolio = dataDetailsPortfolioId;

  const goToSimulator = id => {
    //navigate(`/portfolio-simulation/${id}`);
    navigate(`/simulator/portfolio/form/${id}`);
  };
  const goToInvestment = id => {
    userNotOB
      ? navigate(`/simulator/portfolio/investment/${id}`, { state: { fromCard: true } })
      : navigate('/completeregistration');
  };

  useEffect(() => {
    if (
      user?.['custom:checkid-sign-doc'] &&
      user['custom:checkid-sign-doc'] === 'signature_success'
    ) {
      setUserNotOB(true);
    }
  }, [user]);

  return (
    <ContainerPortfolioDetails>
      <TopSectionPortfolio>
        <CardExpectedReturn>
          <Stack>
            <TypographyTitleExpected>Rentabilidad esperada</TypographyTitleExpected>
          </Stack>
          <Stack
            direction='row'
            spacing={1}
            alignItems='center'
            sx={{
              marginRight: {
                xs: '0px',
                sm: '20px',
              },
            }}>
            <TypographyValueExpected>{fileAs.profit} %</TypographyValueExpected>
            <IconInfo src='/assets/images/perfiles/info.svg' />
          </Stack>
        </CardExpectedReturn>

        <BtnGroupContainer direction={'column'}>
          <ButtonsWrapperStack>
            <BtnGroupPortfolio maxWidth={{ md: '650px', xs: '100%' }}>
              <BtnContainer flexDirection={{ md: 'row', xs: 'column' }} gap={2}>
                <ButtonsSecondary
                  name={simulation}
                  onClick={() => goToSimulator(dataDetailsPortfolioId[0].idModels)}
                  fullWidth
                />
                <ButtonsPrimary
                  name={investmentMore}
                  onClick={() => goToInvestment(dataDetailsPortfolioId[0].idModels)}
                  fullWidth
                />
              </BtnContainer>
              {statusDividendFinfolio && (
                <Stack width={'100%'} marginTop={1}>
                  {fileAs.products === true &&
                    (!visible && statusDividendFinfolio.length > 0 ? (
                      <ButtonReInvestment
                        variant='outlined'
                        endIcon={<KeyboardArrowRightIcon />}
                        fullWidth
                        style={{ textTransform: 'none' }}
                        onClick={handleOpen}>
                        <img
                          style={{
                            verticalAlign: 'middle',
                            marginRight: '5px',
                            color: 'red',
                          }}
                          src='/assets/images/edit.svg'
                          alt='edit'
                        />
                        Reinvertir Dividendos
                      </ButtonReInvestment>
                    ) : statusDividendFinfolio.length > 0 ? (
                      <ButtonReInvestment
                        startIcon={<CloseIcon />}
                        endIcon={<KeyboardArrowDownIcon />}
                        variant='outlined'
                        fullWidth
                        style={{ textTransform: 'none' }}
                        onClick={handleClose}>
                        Cancelar
                      </ButtonReInvestment>
                    ) : null)}
                </Stack>
              )}
            </BtnGroupPortfolio>
          </ButtonsWrapperStack>
        </BtnGroupContainer>
      </TopSectionPortfolio>

      <StackDescription>
        <TitleDescription>Descripción</TitleDescription>
        <Description component='p'>
          Este portfolio fue generado mediante la metodología de Resampled efficient frontier, con
          el objetivo de buscar la combinación óptima de fondos de acuerdo al perfil de riesgo.
        </Description>
      </StackDescription>

      <SectionDataPorfolio
        minHeight={'400px'}
        gap={4}
        flexDirection={{ md: 'row', sm: 'column', xs: 'column' }}
        justifyContent={{ md: 'space-between', xs: 'center' }}
        alignItems={{ md: 'center', xs: 'center' }}
        padding={{ md: '0', xs: '0rem' }}>
        <ChartsPorfolio height={'100%'} width={'50%'} maxWidth={'450px'} maxHeight={'450px'}>
          <DataCharts height={'100%'} width={{ md: '100%', xs: '70%' }}>
            <ChartDoughnutXcala dataChart={dataDetailsPortfolio[0].dataChart} />
          </DataCharts>
        </ChartsPorfolio>

        <DistributionsValue dataDetailsPortfolio={dataDetailsPortfolio} />
      </SectionDataPorfolio>

      <InfoPorfolio width={{ md: '100%', xs: '100%' }}>
        <TitelDataPorfolio>Condiciones generales</TitelDataPorfolio>
        <DescriptionDataPorfo gap={2}>
          <DescriptionComponentPortfolio
            KeyDescriptions='Moneda:'
            KeyValues={portfolioDetailsFileAs.currency}
          />
          <DescriptionComponentPortfolio KeyDescriptions='Duración:' KeyValues='Indefinido' />
          <DescriptionComponentPortfolio
            KeyDescriptions='Plazo de rescate:'
            KeyValues='Según reglamento de los fondos'
          />
          <DescriptionComponentPortfolio
            KeyDescriptions='Comisión de salida:'
            KeyValues='Según reglamento de los fondos'
          />
        </DescriptionDataPorfo>
      </InfoPorfolio>

      <Stack
        width={'100%'}
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          paddingY: { md: '40px', xs: '20px' },
          height: '100%',
        }}>
        <BtnGroup
          goToSimulator={() => goToSimulator(dataDetailsPortfolioId[0].idModels)}
          goToInvestment={() => goToInvestment(dataDetailsPortfolioId[0].idModels)}
        />
      </Stack>

      {shouldShowWarning && (
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <img src='/assets/images/warning.svg' alt='risk' style={{ display: 'inline' }} />
          <Typography style={{ color: theme.palette.red.main, marginLeft: '10px' }}>
            Este portfolio supera el riesgo definido en tu perfil{' '}
            {capitalize(user['custom:profile'])}
          </Typography>
        </Box>
      )}

      <Stack paddingLeft='16px'>
        <Grid
          container
          spacing={2}
          borderRadius={2}
          justifyContent={{ xs: 'center', md: 'flex-start' }}
          alignItems='center'
          sx={{ px: 0, minHeight: '188px' }}>
          {dataDetailsPortfolio[0].fund.map((fundName, index) => {
            const colores = dataDetailsPortfolio[0].dataChart.datasets[0].backgroundColor;
            const color = colores[index];

            return (
              <Grid item key={fundName.name} xs={12} sm={6} lg={4} sx={{ padding: 2 }}>
                <CardsContentDocumentacion>
                  <HeaderComponent
                    flexDirection='column'
                    gap={0}
                    p={2}
                    backgroundColor={handleHexToRgba(color)}>
                    <TitleCardsDocumentation>{fundName.name}</TitleCardsDocumentation>
                    <SubTitleCardsDocumentation>
                      Documentación de interés
                    </SubTitleCardsDocumentation>
                  </HeaderComponent>

                  <BodyComponent>
                    <CardsItemDescription width='100%' customData={fundName} />
                  </BodyComponent>
                </CardsContentDocumentacion>
              </Grid>
            );
          })}
        </Grid>
      </Stack>
    </ContainerPortfolioDetails>
  );
};

export default BodyDetailsPorfolio;
